import { AbilitySubjects, UserContextRole } from '../../enums';
import { ABILITY_TYPE_FIELD, IAbilityUser } from '../abilities.types';
import { IAbilityProject } from '../projects';
import { IAbilityTimeSpent, ITimeSpentCalculatedSubject, TimeSpentSubject } from './timeSpentTypes';

export const getTimeSpentSubject = (
    user: IAbilityUser,
    timeSpent?: IAbilityTimeSpent | null,
    project?: IAbilityProject | null,
    input?: {
        userId?: string | null;
    }
): ITimeSpentCalculatedSubject => {
    const relationRole: ITimeSpentCalculatedSubject['relationRole'] = [user.role!];
    const subSubject: TimeSpentSubject[] = [];

    if (user.id === timeSpent?.userId) {
        relationRole.push(UserContextRole.AUTHOR);
    }

    if (project && project.userLinks.some(l => l.userId === user.id && l.role === UserContextRole.PROJECT_USER))
        relationRole.push(UserContextRole.PROJECT_USER);

    if (input?.userId && input.userId !== user.id) subSubject.push(TimeSpentSubject.SPECIFIC_USER);

    return {
        [ABILITY_TYPE_FIELD]: AbilitySubjects.TIME_SPENT,
        relationRole,
        subSubject,
    };
};
